import type { SVGProps } from "react";

export default function ChatIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 374.36 374.3"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Green parts - keep fixed color */}
				<path fill="#3fdfcf" d="M118.19,115.15l-.02-107.52c.08-2.93,1.7-5.39,4.27-6.73C204.53-.55,287.02.06,369.24.6c2.92,1.16,4.89,3.84,4.97,7.03l.03,176.07c.9,2.73-3.26,8.45-5.55,8.45h-21.5l-.06,53.44c-1.49,6.47-8.72,10.39-13.96,5.08l-58-58-18.98-.52c-.01-5.02.01-11.05,0-16,.22-.78.59-1.94,1.19-1.98,3.94-.23,23.75.02,26.12,1.12l44.87,44.24,1.83,4.62-2-4.42v-35.89l2-1.19c-3.39-1.95,3.01-9.75,5.5-6.5l1.12-2h18.47l1.41,2c-1.48-2.17-.86-2.59,1.5-1.5l-2-.7V18.88l2-1.23c-2.17,1.48-2.59.86-1.5-1.5l-.7,2h-219.57l-1.23-2,2,.69v97.08l-2,1.22c-5.65,0-11.35,0-17,0Z" />
				<g>
					{/* Black parts - use currentColor */}
					<path fill="currentColor" d="M118.19,115.15c5.64-1.97,11.36-1.97,17,0l2.49-1.33c33.71-1.51,67.98-3.02,101.83-1.27,16.15.83,18.48,2.11,19.25,18.29.63,13.14.54,29.31-.56,42.38l-2.01,2.94c3.12,3.25,3.11,12.65,0,16,.1,37.83-.1,75.68.02,113.52-.26,6.08-6.14,8.19-11.48,8.52l-145.84.16-59.15,58.85c-5.76,2.99-11.62-.43-12.49-6.62l-.06-52.43H8.69c-2.33,0-6.83-2.82-7.74-5.26-1.27-62.91-1.26-126.54,0-189.49,1.34-2.57,3.8-4.2,6.73-4.27,36.84,0,73.7.07,110.52.02ZM239.19,132.15H16.19v165h22.5c.44,0,5.5,5.64,5.5,6.5v40c0,.41-2.57,1.75.49,1.49,16.49-15.81,31.78-33.06,49.01-47.99h145.5v-165Z" />
					{/* Green parts - keep fixed color */}
					<path fill="#3fdfcf" d="M123.91,207.36c14.7-3.3,14.7,18.88,0,15.58-7.66-1.72-7.68-13.86,0-15.58Z" />
					<path fill="#3fdfcf" d="M183.89,207.37c15.18-4.52,15.18,20.1,0,15.58-6.44-1.92-6.44-13.66,0-15.58Z" />
					<path fill="#3fdfcf" d="M59.49,220.87c-6.89-8.17,5.57-19.31,12.72-11.24,7.85,8.87-6.44,18.69-12.72,11.24Z" />
				</g>
			</g>
		</svg>
	);
}

